import React, { useEffect } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Grid, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import { useFilasEsperaState } from "../context/filas-espera-context";
import { useFilasEsperaController } from "../context/filas-espera-controller";
import { TextInputWithCounter } from "../../../components/text-input-with-counter";
import PlainTextArea from "../../../components/plain-text-area";

export const FilaEsperaForm = () => {
    const { dataRequest, tiposList } = useFilasEsperaState();
    const { handleOnChangeForm, loadLookups } = useFilasEsperaController();
    const tipoSelecionado = tiposList?.find(t => t.id === dataRequest?.idTipoFilaEspera);
    const isCreche = tipoSelecionado?.name === 'Creche';

    useEffect(() => {
        (async () => {
            await loadLookups();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid item lg={6} sm={6} xl={6}>
                        <InputLabel>Tipo de Fila *</InputLabel>
                        <Select
                            size="small"
                            error={!dataRequest?.idTipoFilaEspera}
                            value={dataRequest?.idTipoFilaEspera ?? ''}
                            onChange={(e) => handleOnChangeForm('idTipoFilaEspera', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            {tiposList?.slice().sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')).map((t) => <MenuItem value={t.id} key={t.id}>{t.name}</MenuItem>)}
                        </Select>
                    </Grid>

                    <Grid item lg={6} sm={6} xl={6}>
                        <InputLabel>Unidade</InputLabel>
                        <TextInputWithCounter
                            size="small"
                            maxLength={150}
                            value={dataRequest?.nomeUnidade || ''}
                            onChange={(e) => handleOnChangeForm('nomeUnidade', e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={4} sm={4} xl={4}>
                        <InputLabel>Quantidade Aguardando *</InputLabel>
                        <OutlinedInput
                            size="small"
                            type="number"
                            error={dataRequest?.quantidadeAguardando === null || dataRequest?.quantidadeAguardando === undefined}
                            value={dataRequest?.quantidadeAguardando ?? ''}
                            onChange={(e) => handleOnChangeForm('quantidadeAguardando', e.target.value === '' ? null : Number(e.target.value))}
                            fullWidth
                        />
                    </Grid>

                    {isCreche && (
                        <>
                            <Grid item lg={4} sm={4} xl={4}>
                                <InputLabel>Vagas Totais</InputLabel>
                                <OutlinedInput
                                    size="small"
                                    type="number"
                                    value={dataRequest?.quantidadeVagasTotais ?? ''}
                                    onChange={(e) => handleOnChangeForm('quantidadeVagasTotais', e.target.value === '' ? null : Number(e.target.value))}
                                    fullWidth
                                />
                            </Grid>

                            <Grid item lg={4} sm={4} xl={4}>
                                <InputLabel>Matriculados</InputLabel>
                                <OutlinedInput
                                    size="small"
                                    type="number"
                                    value={dataRequest?.quantidadeMatriculados ?? ''}
                                    onChange={(e) => handleOnChangeForm('quantidadeMatriculados', e.target.value === '' ? null : Number(e.target.value))}
                                    fullWidth
                                />
                            </Grid>
                        </>
                    )}

                    <Grid item lg={4} sm={4} xl={4}>
                        <InputLabel>Data de Atualização *</InputLabel>
                        <DesktopDatePicker
                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small", error: !dataRequest?.dtaAtualizacao } }}
                            value={dataRequest?.dtaAtualizacao ? dayjs(dataRequest.dtaAtualizacao) : null}
                            onChange={(value: Dayjs | null) => handleOnChangeForm('dtaAtualizacao', value?.toISOString())}
                        />
                    </Grid>

                    <Grid item lg={12} sm={12} xl={12}>
                        <InputLabel>Critérios de Priorização</InputLabel>
                        <PlainTextArea
                            size="small"
                            rows={3}
                            value={dataRequest?.textoCriteriosPriorizacao || ''}
                            onChange={(e: any) => handleOnChangeForm('textoCriteriosPriorizacao', e.target.value)}
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    );
};
